import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_tabs = _resolveComponent("tabs")!
  const _component_details_bar = _resolveComponent("details-bar")!
  const _component_q_page_sticky = _resolveComponent("q-page-sticky")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "bg-white" }, {
    default: _withCtx(() => [
      _createVNode(_component_loader, { task: _ctx.task }, null, 8, ["task"]),
      (_ctx.client)
        ? (_openBlock(), _createBlock(_component_tabs, {
            key: _ctx.client.id,
            client: _ctx.client,
            tab: _ctx.tab,
            style: {"margin-top":"4.5rem"}
          }, null, 8, ["client", "tab"]))
        : _createCommentVNode("", true),
      _createVNode(_component_q_page_sticky, {
        expand: "",
        position: "top"
      }, {
        default: _withCtx(() => [
          (_ctx.client)
            ? (_openBlock(), _createBlock(_component_details_bar, {
                key: 0,
                client: _ctx.client,
                class: "bg-white q-px-lg fit shadow-1"
              }, null, 8, ["client"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}